import {
    ImageSegmenter,
    // SegmentationMask,
    FilesetResolver
} from "@mediapipe/tasks-vision";

export default class GrmImageSegmenter {
    options={}
    _props = {
        monitor: []
    }

    constructor(options) {
        Object.assign(this.options, options);
    }

    async init () {
        if(this.imageSegmenter){
            return this;
        }

        const {options} = this;
        if(!options.imageSegmenter) options.imageSegmenter = {};
        await (async () => {
            const vision = await FilesetResolver.forVisionTasks(
                options.libs?.urls.visionTasks
                || "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.21/wasm"
                // || "@mediapipe/tasks-vision/wasm"
            );

            const createOptions = Object.assign({
                runningMode: 'VIDEO',
                // numPoses: 1,
                outputCategoryMask: true,
                outputConfidenceMasks: true,
                displayNamesLocale: 'en',
            }, options.imageSegmenter, {
                baseOptions: Object.assign({
                    modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/image_segmenter/deeplab_v3/float32/1/deeplab_v3.tflite',
                    delegate: 'GPU'
                }, options.imageSegmenter.baseOptions),
            });

            this.imageSegmenter = await ImageSegmenter.createFromOptions(vision, createOptions);

            const labels = this.imageSegmenter.getLabels()
            Object.assign(this._props, {
                createOptions,
                labels,
                personLabelIndex: labels.findIndex(v => v === 'person')
            })
        })();

        return this;
    }

    async setRunningMode (mode) {
        const {createOptions} = this._props;
        if(createOptions.runningMode !== mode){
            createOptions.runningMode = mode;
            await this.imageSegmenter.setOptions({
                runningMode: mode
            });
        }
    }

    async _parseResult (result) {
        const {labels, personLabelIndex} = this._props;
        const mask = result.categoryMask.getAsUint8Array();

        let category = [];
        let labelIndex = {};
        for (let i in mask) {
            const idx = mask[i];
            if (idx > 0) {
                const label = labels[mask[i]];
                if(label){
                    if(!labelIndex[label]){
                        category.push(label);
                        labelIndex[label] = true;
                    }
                }
            }
        }
        return {
            data: result,
            hasPerson: mask.includes(personLabelIndex),
            category
        }
    }

    async segmentForVideo (video) {
        await this.setRunningMode('VIDEO');
        const result = await new Promise((resolve, reject) => {
            this.imageSegmenter.segmentForVideo(video, performance.now(), (result) => {
                resolve(result);
            });
        });
        return this._parseResult(result);
    }

    async segment (image) {
        await this.setRunningMode('IMAGE');

        let imgData = image;
        if(globalThis.HTMLVideoElement && image instanceof HTMLVideoElement){
            imgData = await createImageBitmap(image);
        }
        const result = await new Promise((resolve, reject) => {
            this.imageSegmenter.segment(imgData, (result) => {
                resolve(result);
            });
        });
        return this._parseResult(result);
    }

    async segmentMonitorForVideo ({
      video,
      detectIntervalMs,
      callback
    }) {
        const {monitor} = this._props;
        const id = 'smt-'+performance.now();

        const RunData = {
            id,
            video,
            run: true,
            destroy: false,
            timer: null,
            lastVideoTime: -1,
            detectCount: 0,
            callbackData: {
                changeDetectIntervalMs: (ms) => {
                    if(detectIntervalMs !== ms && video.srcObject){
                        const track = video.srcObject.getVideoTracks()[0];
                        if(track){
                            const frameRate = track.getSettings().frameRate;
                            ms = Math.max(ms, 1000 / frameRate);
                        }
                    }

                    detectIntervalMs = ms;
                    if(RunData.run){
                        if(RunData.runTimer){
                            clearTimeout(RunData.runTimer);
                        }
                        RunData.runTimer = setTimeout(() => {
                            delete RunData.runTimer;
                            globalThis.requestAnimationFrame(segmentVideo);
                        }, detectIntervalMs || 1000);
                    }
                },
                pause: () => {
                    if(!RunData.run) return;
                    clearTimeout(RunData.runTimer);
                    RunData.run = false;
                    video.pause();
                },
                resume: () => {
                    if(RunData.destroy){
                        throw 'destroyed';
                    }
                    if(RunData.run) return;
                    RunData.run = true;
                    RunData.lastVideoTime = video.currentTime;
                    segmentVideo();
                },
                destroy: function(){
                    this.pause();
                    let idx = monitor.findIndex(m => m === RunData);
                    if(idx > -1){
                        monitor.splice(idx, 1);
                    }
                    RunData.destroy = true;
                },
                isDestroyed: function(){
                    return RunData.destroy;
                }
            }
        };

        const segmentVideo = async () => {
            if(!RunData.run){
                return;
            }
            let paused = video.paused;
            if (RunData.lastVideoTime !== video.currentTime) {
                if (RunData.lastVideoTime !== video.currentTime) {
                    RunData.lastVideoTime = video.currentTime;
                }
                const result = await this.segmentForVideo(video);
                Object.assign(RunData.callbackData, {
                    data: result,
                });
                callback(RunData.callbackData);
            }else if(video.currentTime === 0){
                if(
                    isNaN(video.duration)
                    || !video.srcObject
                    || !video.src
                ){
                    paused = true;
                }
            }

            if(paused){
                return;
            }
            RunData.callbackData.changeDetectIntervalMs(detectIntervalMs || 1000)
        }

        if(video.paused){
            video.addEventListener('playing', e => {
                segmentVideo();
            });
            video.play().catch(e => {
                console.error(e);
            })
        }else{
            segmentVideo();
        }
        monitor.push(RunData);
    }

    async segmentMonitorForStream ({
        stream,
        detectIntervalMs,
        callback
    }) {
        const video = document.createElement('video');
        video.muted = true;
        video.playsInline = true;
        video.srcObject = stream;

        this.segmentForVideo({video, detectIntervalMs, callback});
    }
}